import {User} from '../../models/user';
import {BijbError} from '../../models/bijb-error';
import {LoadableState} from './loadable-state';
import {autoserializeAs, inheritSerialization} from 'cerialize';

@inheritSerialization(LoadableState)
export class CurrentUserState extends LoadableState {
  public static readonly key = 'CurrentUserState';

  @autoserializeAs(User, 'user')
  public user: User = null;

  @autoserializeAs(BijbError, 'error')
  public error: BijbError;
}
